// 访问路径已开启proxy代理，url已弃用，代理地址见package.json
export default {
    // url: 'https://test-renter-mobile.izuche.com/renter-mobile-web',
    // preUrl: 'https://pre-renter-mobile.izuche.com/renter-mobile-web',
    // devUrl: 'https://dev-renter-mobile.izuche.com/renter-mobile-web',
    // testUrl: 'https://test-renter-mobile.izuche.com/renter-mobile-web',
    cryptoBool: true,
    version: '1.0.0',
    short_version: '1',
    sqzlKey: 'sqzl8f9782735fbae831d58005b' //测试环境密匙
}
